module.exports = __webpack_public_path__ + "static/media/img_dog_small.870eb34f.svg";